import { useParams } from 'react-router-dom';
import { FairShell, FairState } from '@/components/jobfairs/FairShell';
import { FairHero, FairSections, FairDetail, FairVenue } from '@/components/jobfairs/FairSections';
import { useFair } from '@/components/jobfairs/useFair';

export default function JobFairLanding() {
  const { slug } = useParams();
  const { fair, error, loading } = useFair(slug);
  if (!fair) return <FairState loading={loading} error={error} />;
  return (
    <FairShell fair={fair}>
      <div data-testid="jobfair-landing">
        <FairHero fair={fair} />
        <FairDetail fair={fair} />
        <FairSections fair={fair} />
        <FairVenue fair={fair} />
      </div>
    </FairShell>
  );
}
